import React from "react";
import { useNavigate } from "react-router-dom";
//netlify setting backup
export default function AboutSuperCoolPage() {
  const navigate = useNavigate();

  const handleBookNow = () => {
    const phone = localStorage.getItem("userPhone");
    if (phone) {
      // logged in → home page
      navigate("/home");
    } else {
      // not logged in → login page
      navigate("/home");
    }
  };

  return (
    <div
      style={{
        padding: "40px 0",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        border: "1px solid #ccc",
        maxWidth: "100%",
        boxSizing: "border-box",
        margin: 0,
        position: "relative", // ✅ Added so ❌ button stays positioned correctly
      }}
    >
      {/* ❌ X Button */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
          color: "black",
        }}
      >
        ✖
      </button>

      <div style={{ padding: "0 20px" }}>
        <h2 style={{ fontSize: "24px", marginBottom: "10px" }}>About CoolFix</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          <b>CoolFix</b> is your go-to destination for fast, reliable, and affordable home and office services. 
          Our mission is to make your life easier by providing a wide range of services under one roof, ensuring quality, transparency, and convenience.
        </p>

        {/* ✅ Current Services */}
        <h3 style={{ fontSize: "20px", marginTop: "20px" }}>What We Offer Today</h3>
        <ul
          style={{
            paddingLeft: "20px",
            fontSize: "15px",
            marginTop: "10px",
          }}
        >
          <li>✅ AC Servicing & Repair</li>
          <li>✅ Gas Refilling & Installation/Uninstallation</li>
          <li>✅ Experienced Technicians</li>
          <li>✅ Transparent Pricing</li>
          <li>✅ Easy Online Booking</li>
          <li>✅ Services for all major AC types</li>
        </ul>

        <p style={{ fontSize: "16px", marginTop: "15px" }}>
          Whether you need <b>AC Servicing</b>, <b>AC Repair</b>, <b>Gas Refilling</b>, or 
          <b> Installation or Uninstallation</b>, we are just a click away!
        </p>

        {/* ✅ Future Plans */}
        <h3 style={{ fontSize: "20px", marginTop: "20px" }}>Our Future Plans</h3>
        <p style={{ fontSize: "16px", lineHeight: "1.6" }}>
          We are constantly growing to meet your needs! In the near future, CoolFix will expand its services to include:
        </p>
        <ul
          style={{
            paddingLeft: "20px",
            fontSize: "15px",
            marginTop: "10px",
          }}
        >
          <li>⚡ Electrical Services</li>
          <li>🚰 Plumbing Services</li>
          <li>🖼 Wallpaper Installation & Decoration</li>
          <li>🛋 Furniture Assembly & Home Organization</li>
          <li>💇 Personal Care Services like Hair Cutting at Home</li>
        </ul>

        <p style={{ fontSize: "16px", marginTop: "15px" }}>
          At CoolFix, we aim to be your one-stop solution for all home and office needs. 
          Whether it’s maintenance, repairs, or new installations, we are committed to making your life hassle-free and comfortable.
        </p>

        {/* 📌 Book Now Button */}
        <button
          onClick={handleBookNow}
          style={{
            marginTop: 20,
            backgroundColor: "#2980b9",
            color: "white",
            padding: "12px 24px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          🚀 Book Now
        </button>
      </div>
    </div>
  );
}
